import { Injectable } from "@angular/core";
import {
  CanLoad,
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  ActivatedRoute,
} from "@angular/router";
import { UserService } from "./shared/service/user.service";
import { EmployeeService } from "./shared/service/employee.service";
import * as moment from "moment-timezone";

@Injectable()
export class CanActivateGuard implements CanActivate {
  offboardingList: any = {};
  getOffboardingDetailsByIdDataList: any = "";
  LoginEmpCode = "";
  isExitDate = "";
  empCode_ID: any;
  empCode: any;

  constructor(
    private router: Router,
    private _userService: UserService,
    // private route: ActivatedRoute,
    private empsvc: EmployeeService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // route.params.subscribe((params) => {
    //   this.empCode_ID = params["empCode"];
    //   sessionStorage.setItem("empCode", params["empCode"])
    // });

    const empCode = route.params["empCode_ID"];
    this.empCode_ID = empCode;

    function getAllTimeZonesInIST(inputDate = null) {
      const istZone = 'Asia/Kolkata';

      const defaultDate = moment.tz(0, 'UTC');

      const baseTime = inputDate ? moment(inputDate) : defaultDate;

      const istTime = baseTime.tz(istZone).format('YYYY-MM-DD HH:mm:ss');

      return new Date(istTime);
    }


    // Store empCode in sessionStorage
    sessionStorage.setItem("empCode_ID", empCode);

    this.LoginEmpCode = this._userService.getEmpCode().toString();
    this.offboardingList = this._userService.getLWDDetails();
    this.getOffboardingDetailsByIdDataList =
      this._userService.getOffboardingDetailsByIdData();
    this.isExitDate = this._userService.getExitDate();

    this.empCode = this._userService.getEmpCode();
    // To get user's photo
    // this.getProfilePicture();

    //console.log("=======empCode_ID===", this.empCode_ID);
    if (
      (this.empCode_ID && this.empCode_ID !== null) &&
      (sessionStorage.getItem("empCode_ID") &&
        sessionStorage.getItem("empCode_ID") != null)
    ) {
      //console.log("=======if===");
      const paramsId = this.empCode_ID || sessionStorage.getItem("empCode_ID");
      const temp_val = paramsId.split("-");
      this.empsvc
        .getOffboardingDetailsById(temp_val[1])
        .subscribe((data: any) => {
          const finalData = data;
          //console.log( "======weekend employee=======1", finalData,finalData.EmpCode, this.empCode  );
          if (finalData != null && finalData.EmpCode == this.empCode) {
          //  console.log("======If=======1");
            window.location.href =
              "https://winemployee.winwire.com/" +
              "myprofile/" +
              this.empCode;
          } else {
            //console.log("======Else=======1");
            window.location.href =
              "https://winhr.azurewebsites.net/" +
              "Offboardinglist/tabIndex/0";
          }
        });
    } else {
      const LWDDetails =
        (this.offboardingList &&
          this.offboardingList.find(
            ({ EmpCode }) => EmpCode.toString() === this.LoginEmpCode
          )) ||
        {};

      if (this._userService.checkPageAccess(state.url)) {
        let isExitDateGraterthanToday = false;
        let today = new Date();
        //let dateOfExit = new Date(this.isExitDate);
        let dateOfExit = getAllTimeZonesInIST(this.isExitDate)
        const defaultDateOfExit = dateOfExit.getFullYear();

        if (defaultDateOfExit !== 1970 && dateOfExit && today > dateOfExit) {
          isExitDateGraterthanToday = true;
        }
        else if(defaultDateOfExit !== 1970 && dateOfExit && today == dateOfExit){
          isExitDateGraterthanToday = true;
        }
        else {
          isExitDateGraterthanToday = false;
        }

        if (
          (LWDDetails && LWDDetails.LastWorkingDay) ||
          isExitDateGraterthanToday
        ) {
          this.router.navigate(["/EmployeeWithoutPermission"]);
        } else {
          return true;
        }
      } else {
        this.router.navigate(["/EmployeeWithoutPermission"]);
      }
    }
  }
}
